import { render, staticRenderFns } from "./BigChallengePage.vue?vue&type=template&id=2f5150a3&scoped=true"
import script from "./BigChallengePage.vue?vue&type=script&lang=js"
export * from "./BigChallengePage.vue?vue&type=script&lang=js"
import style0 from "./BigChallengePage.vue?vue&type=style&index=0&id=2f5150a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5150a3",
  null
  
)

export default component.exports